import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { StyledLoaderWrapper } from "./common.styles";

const LoaderComponent = ({ description }) => {
  return (
    <StyledLoaderWrapper>
      <CircularProgress size="large" color="primary" /><br />
      {description && (
        <Typography>{description}</Typography>
      )}
    </StyledLoaderWrapper>
  );
};

export default LoaderComponent;
